import { createTheme, lightThemePrimitives } from 'baseui';

const customFontFamily = 'Poppins, sans-serif';
const cutomFontSize14px = '14px';

export const customBaseUiTheme = createTheme(
  {
    ...lightThemePrimitives,
    primaryFontFamily: customFontFamily,
  },
  {
    typography: {
      font100: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font200: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font300: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font400: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font500: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font600: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font700: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font800: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font900: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
      font1000: {
        fontFamily: customFontFamily,
        fontSize: cutomFontSize14px,
      },
    },
    // Button customization
    buttons: {
      default: {
        borderRadius: '8px',
      },
      primary: {
        borderRadius: '8px',
      },
      secondary: {
        borderRadius: '8px',
      },
      tertiary: {
        borderRadius: '8px',
      },
    },
    colors: {
      notificationInfoBackground: '#E9F3FF',
      notificationInfoText: '#004DC9',
      primaryColor: '#004dc9',
      warningColor: '#cf2020',
      blackColor1: '#0f0f0f',
      blackColor2: '#333',
      blackColor3: '#666',
      blackColor4: '#262626',
      lightGreyColor: '#ededed',
      lightGreyColor2: '#f8f8f8',
      lightGreyColor3: '#d9d9d9',
      greyColor1: '#a3a3a8',
      whiteColor: '#fff',
      successIndicatorColor: '#1f7a37',
      linkFocusColor: '#2137b4',
      textSecondary: '#444',
      primaryButtonColor: '#2f6ae3',
      dangerColor: '#7d1c1c',
      dangerBackground: '#ffe5e6',
      succesIndicator: '#EBFAEF',
      infodim: '#A8CCF8',
      infoBorder: '#42AAFF',
      disabled: '#A3A3A3',
      blackColor5: '#171717',
      warningDim: '#FFECB2',
      warningColor: '#856914',
      warningContainer: '#FFF9E5',
      warningBackground: '#FFF9E5',
      warningColor2: '#856914',
    }
  }
);
